module.exports = __webpack_public_path__ + "static/media/back_to_top.b98039a1.svg";